import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/people-with-thumbs-up.svg'


const _hoisted_1 = { class: "my-lg-5 my-md-7 my-2" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col col-lg-6 d-none d-lg-block text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "pl-5 pr-5",
    src: _imports_0,
    alt: "people with thumbs up signs"
  })
], -1)
const _hoisted_4 = { class: "col col-md-9 col-lg-6 mx-auto" }
const _hoisted_5 = { class: "card d-lg-none bg-light shadow-sm py-3 mb-3" }
const _hoisted_6 = { class: "col d-flex d-none align-items-center" }
const _hoisted_7 = {
  class: "mr-3 badge badge-success px-3 py-2 shadow-sm align-self-center",
  style: {"font-size":"150%","border-radius":"10px"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "text-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "h4" }, "Congratulation!"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-muted" }, "Your registration is complete")
], -1)
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"card shadow-sm pb-3\"><div class=\"card-body\"><div class=\"pb-3 mb-3 border-bottom\"><div class=\"h3 mb-1\">Thank You!</div></div><span class=\"lead\"> Thank you for registering. Your account is currently under review, and one of our team members will contact you within the next few business hours. </span></div></div>", 1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "row pt-5 mt-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-6" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_font_awesome_icon, { icon: "check-circle" })
            ]),
            _hoisted_8
          ])
        ]),
        _hoisted_9
      ])
    ]),
    _hoisted_10
  ]))
}